import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import Pagination from "../common/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";

import {
  TrashBinIcon,
  PencilIcon
} from "../../icons";
import { Link } from "react-router";
import Badge from "../ui/badge/Badge";
import { getAllSubscriptions, deleteSubscriptionPlanById, emptyRedux } from "../../actions/subscriptionAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { configPaths } from '../../config';

export default function AllPlans() {

  dayjs.extend(relativeTime);

  const perpage = configPaths.recordsPerPage;

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const [subData, setSubData] = useState([]);

  const [loadData, setLoadData] = useState(true);

  const getAllSubscriptionsRes = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlan);

  const getAllSubscriptionsFailed = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlanFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showModal, setShowModal] = useState(false);

  const [planToDelete, setPlanToDelete] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
      dispatch(checkAuth());
      dispatch(getAllSubscriptions(perpage,1));
  }, []);

  useEffect(() => {
    console.log("Logged out error");
    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      logout();
      navigate("/signin");
    }

  }, [checkAuthFailed]);

  useEffect(() => {
      
    if(typeof getAllSubscriptionsRes != "undefined" && getAllSubscriptionsRes.statusCode == 200){
      let data = [];

      let planlist = getAllSubscriptionsRes.data.plans;
      const planData = planlist.map((item) => {
              return {
                "id": item.id,
                "name": item.name,
                "tenure": item.tenure,
                "amount": item.amount,
                "scheduleType": item.scheduleType,
                "schedule": item.schedule,
                "createdAt": item.createdAt,
                "subscribersCount": item.subscribersCount
              };
      });

      console.log("planData", planData);
      setLoadData(false);
      setSubData([
          ...planData
      ]);

      setTotalRecords(getAllSubscriptionsRes.data.count);

    }

  }, [getAllSubscriptionsRes]);

  useEffect(() => {
    //console.log(getAllCustomerFailed);
    if(getAllSubscriptionsFailed.statusCode == 401 || getAllSubscriptionsFailed.statusCode == 500){

          //toast.error(getAllCustomerFailed.message, {autoClose:2000,onClose: () => {

                //logout();
                //navigate("/signin");
          //}});
          setLoadData(false);
    }
  }, [getAllSubscriptionsFailed]);
  
  const handleDeleteClick = (id) => {
    setPlanToDelete(id);
    setShowModal(true);  // Show the confirmation modal
  };

  const handleConfirmDelete = () => {
    dispatch(deleteSubscriptionPlanById(planToDelete));
    setSubData(subData.filter(c => c.id !== planToDelete));  // Remove the deleted plan from the state
    setShowModal(false);  // Close the modal
    toast.success("Subscription Plan deleted successfully", {
      position: "bottom-right",
      autoClose: 4000,
    });
  };
  
  const handleCancelDelete = () => {
    setShowModal(false);  // Close the modal without doing anything
  };

  const handlePgNav = (typ) => {
    let pgNum = typ === "next" ? currentPage + 1 : currentPage - 1;

    if(pgNum < 1 || pgNum > Math.ceil(totalRecords / perpage)){
      return;
    }

    setCurrentPage(pgNum);
    setLoadData(true);
    dispatch(getAllSubscriptions(perpage, pgNum));
  };

  const handleChangePg = (pgNum) => {
    if(!isNaN(pgNum) && pgNum !== currentPage){
      setCurrentPage(pgNum);
      setLoadData(true);
      dispatch(getAllSubscriptions(perpage, pgNum));
    }
  };

  return (
    <>
      <PageMeta
        title="Subscription plans | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscription plan" />
      <div className="space-y-6">
        <ComponentCard title="All plans list" btn="/subscription/add">
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <div className="min-w-[1102px]">
                <Table>
                  {/* Table Header */}
                  <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                    <TableRow>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Plan name
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Plan Type
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Subscribers
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Tenure
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Amount
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Created At
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHeader>

                  {/* Table Body */}
                  <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                    {
                      subData.length > 0 
                      ? 
                      subData.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell className="px-5 py-4 sm:px-6 text-start">
                          <div className="flex items-center gap-3">
                            <div>
                              <span className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                                {item.name}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.scheduleType}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          <a
                            href={"/subscription/users/"+item.id}
                            aria-describedby={item.id}
                            className={'text-indigo-600 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-1.5 text-center text-sm '}
                          >
                            {item.subscribersCount}
                          </a>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {(
                            item.scheduleType === "fixed"
                            ?
                            item.tenure + ' ' + (item.schedule == "monthly" ? "month(s)" : (item.schedule == "weekly" ? "week(s)" : "year(s)"))
                            :
                            "-"
                          )}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          <div className="flex -space-x-2">
                          {(
                            item.scheduleType === "fixed"
                            ?
                            <>&#8377; {item.amount}</>
                            :
                            "-"
                          )}
                          </div>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          {dayjs(item.createdAt).format('DD/MM/YYYY') }
                        </TableCell>
                        <TableCell className="text-center px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          <div className="flex flex-cols-2 gap-6 xl:grid-cols-2">
                            <div className="space-y-6">
                            <Link
                              to={"/subscription/edit/"+item.id}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <PencilIcon />
                            </Link>
                            </div>
                            <div className="space-y-6">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleDeleteClick(item.id)}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <TrashBinIcon />
                            </Link>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                      
                    ))
                    :
                    <TableRow>
                      <td colSpan={7} className="text-center py-6 text-gray-500">{(loadData === true ? "Loading..." : "No Records Found..!" )}</td>
                    </TableRow>
                  }
                  </TableBody>
                </Table>
              </div>
              {/* Pagination */}
              {
                subData.length > 0 
                ?
                <Pagination
                  totalRecords={totalRecords}
                  perPage={perpage}
                  currentPage={currentPage}
                  handlePgNav={handlePgNav}
                  handleChangePg={handleChangePg}
                />
                :
                null
              }
              
            </div>
          </div>
        </ComponentCard>
      </div>
      {/* Custom Confirmation Modal using Tailwind CSS */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-lg font-semibold text-gray-700">Confirm Deletion</h3>
            <p className="text-gray-600 mt-2">Are you sure you want to delete this Subscription Plan?</p>
            <div className="mt-4 flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={handleCancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
}